import React from 'react';
import PropTypes from 'prop-types';

const PriceMatrixHead = (props) => {
  const { leadTimes } = props;
  const text = (d) => `${d} ${d === 1 ? 'week' : 'weeks'}`;

  return (
    <thead>
      <tr>
        <th className="qty">Qty</th>
        {leadTimes.map((qty) => <th key={qty}>{text(qty)}</th>)}
      </tr>
    </thead>
  );
};

PriceMatrixHead.defaultProps = {
  leadTimes: [],
};

PriceMatrixHead.propTypes = {
  leadTimes: PropTypes.arrayOf(PropTypes.number),
};

export default PriceMatrixHead;
